import {useMemo} from 'react';
import {generateRandomString} from '../string-generator';

export function useId(): string {
	return useMemo(() => generateRandomString(10), []);
}
